import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { AllowedOperation, ClassName, RoleService } from '@sim/role';

import { Menus } from '@atmi/core/models';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  get menus(): Menus {
    return [
    {
      available: () => true,
      disable: () => false,
      items: [
        {
          available: () => this.isMenuItemAllow('BeneOA', ['read', 'read+all']),
          disable: () => false,
          label: this.translate.instant('Oggetti artistici'),
          path: '/cards?card=0'
        },
        {
          available: () => this.isMenuItemAllow('BeneS', ['read', 'read+all']),
          disable: () => false,
          label: this.translate.instant('Stampe'),
          path: '/cards?card=1'
        },
        {
          available: () => this.isMenuItemAllow('BeneMI', ['read', 'read+all']),
          disable: () => false,
          label: this.translate.instant('Matrici incise'),
          path: '/cards?card=3'
        },
        {
          available: () => this.isMenuItemAllow('BeneF', ['read', 'read+all']),
          disable: () => false,
          label: this.translate.instant('Fotografie'),
          path: '/cards?card=2'
        },
        {
          available: () => this.isMenuItemAllow('BeneD', ['read', 'read+all']),
          disable: () => false,
          label: this.translate.instant('Disegni'),
          path: '/cards?card=4'
        },
        {
          available: () => this.isMenuItemAllow('Base', ['read', 'read+all']),
          disable: () => true,
          label: this.translate.instant('Basi'),
          path: '/base',
        },
      ],
      label: this.translate.instant('Beni'),
    },
    {
      available: () => this.isMenuItemAllow('Vocabolario', ['read', 'read+all']),
      disable: () => false,
      icon: '',
      label: this.translate.instant('Gestione vocabolari'),
      path: '/vocabularies',
    },
    {
      available: () => {
        return this.isMenuItemAllow('DocumentoBib', ['read', 'read+all']) &&
          this.isMenuItemAllow('DocumentoArc', ['read', 'read+all']);
      },
      disable: () => false,
      items: [
        {
          available: () => this.isMenuItemAllow('DocumentoBib', ['read', 'read+all']),
          disable: () => false,
          icon: '',
          label: this.translate.instant('Bibliografici'),
          path: '/bibs-sources',
        },
        {
          available: () => this.isMenuItemAllow('DocumentoArc', ['read', 'read+all']),
          disable: () => false,
          icon: '',
          label: this.translate.instant('Archivistici'),
          path: '/archival-sources',
        },
      ],
      label: this.translate.instant('Documenti'),
    },
    {
      available: () => this.isMenuItemAllow('Collezione', ['read', 'read+all']),
      disable: () => false,
      icon: '',
      label: this.translate.instant('Collezioni'),
      path: '/collections',
    },
    {
      available: () => this.isMenuItemAllow('File', ['read', 'read+all']),
      disable: () => false,
      icon: '',
      label: this.translate.instant('Media'),
      path: '/media',
    },
    {
      available: () => this.isMenuItemAllow(),
      disable: () => false,
      items: [
        {
          available: () => true,
          disable: () => false,
          icon: '',
          label: this.translate.instant('Persone'),
          path: '/people',
        },
        {
          available: () => true,
          disable: () => false,
          icon: '',
          label: this.translate.instant('Utenti'),
          path: '/users',
        },
        {
          available: () => true,
          disable: () => false,
          icon: '',
          label: this.translate.instant('Ruoli'),
          path: '/roles',
        },
        {
          available: () => true,
          disable: () => false,
          icon: '',
          label: this.translate.instant('Operazioni'),
          path: '/audits',
        },
        {
          available: () => true,
          disable: () => false,
          icon: '',
          label: this.translate.instant('Release notes'),
          path: '/release_notes',
        },
      ],
      label: this.translate.instant('Sistema'),
    }
  ];
  }

  constructor(
    private readonly roleService: RoleService,
    private readonly translate: TranslateService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    // Subscribe to role changes to update menus when role loads
    this.roleService.role$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private isMenuItemAllow(className?: ClassName, allowedOperations?: AllowedOperation) {
    return this.roleService.hasCapability(className, allowedOperations);
  }
}
